import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  changeMatchGoals,
  checkAllFilled,
  calcBtnClicked,
  updateTeamScore,
  calcGroupRanking,
  goTo16,
} from "../features/teamSlice";
import { getFlagUrl } from "../features/getFlagUrl";

function GroupStage() {
  const groupList = useSelector((state) => state.team.groups);
  const dispatch = useDispatch();
  useEffect(() => {
    for (let i = 0; i < groupList.length; i++) {
      dispatch(checkAllFilled(i));
    }
  });
  const changeTeamGoals = (event, index, idx, teamIdx) => {
    dispatch(
      changeMatchGoals({
        groupIdx: index,
        matchIdx: idx,
        matchTeamIdx: teamIdx,
        teamGoals: event.target.value,
      })
    );
    dispatch(checkAllFilled(index));
  };
  const calcRanking = (groupIndex) => {
    dispatch(calcBtnClicked(groupIndex));
    dispatch(checkAllFilled(groupIndex));
    if (groupList[groupIndex].isAllFilled) {
      for (let i = 0; i < groupList[groupIndex].matches.length; i++) {
        for (let j = 0; j < groupList[groupIndex].teams.length; j++) {
          if (
            groupList[groupIndex].teams[j].nation ===
            groupList[groupIndex].matches[i].matchTeams[0].nation
          ) {
            dispatch(
              updateTeamScore({
                groupIdx: groupIndex,
                teamIdx: j,
                goalF: Number(
                  groupList[groupIndex].matches[i].matchTeams[0].goals
                ),
                goalC: Number(
                  groupList[groupIndex].matches[i].matchTeams[1].goals
                ),
              })
            );
          } else if (
            groupList[groupIndex].teams[j].nation ===
            groupList[groupIndex].matches[i].matchTeams[1].nation
          ) {
            dispatch(
              updateTeamScore({
                groupIdx: groupIndex,
                teamIdx: j,
                goalF: Number(
                  groupList[groupIndex].matches[i].matchTeams[1].goals
                ),
                goalC: Number(
                  groupList[groupIndex].matches[i].matchTeams[0].goals
                ),
              })
            );
          }
        }
      }
      dispatch(calcGroupRanking(groupIndex));
    }
  };
  const nextAvailable = () => {
    let atLeastOneGroupFilled = false;
    let atLeastOneGroupClicked = false;
    for (let i = 0; i < groupList.length; i++) {
      atLeastOneGroupFilled |= groupList[i].isAllFilled;
      atLeastOneGroupClicked |= groupList[i].isCalcBtnClicked;
    }
    let atLeastOneGroupReady = atLeastOneGroupClicked & atLeastOneGroupFilled;
    return atLeastOneGroupReady;
  };

  return (
    <section className="mt-2">
      <section className="text-center">
        <h1 className="mb-0 title">
          ¿Quién será el campeón de Qatar 2022? <br />
          <span id="indica" >Indica cuántos goles hará cada equipo en cada partido</span>
        </h1>
        <div className="w-100 mx-auto my-3 separator"></div>
      </section>
      <section className="row my-3 px-2 px-md-0">
        {groupList.map((groupItem, index) => {
          return (
            <section key={index} className="col-12 col-md-6 px-1 px-md-2">
              <section>
                <h2 className="my-2 text-center group-name">
                  {groupItem.groupName}
                </h2>
                <div>
                  <section className="row mx-auto px-0">
                    {groupItem.matches.map((match, idx) => {
                      return (
                        <div
                          className="row mx-auto px-0"
                          key={`group_match` + index + idx}
                        >
                          {match.matchTeams.map((matchTeam, matchTeamIndex) => {
                            return (
                              <section
                                className="col-6 px-0"
                                key={
                                  `match_team` + index + idx + matchTeamIndex
                                }
                              >
                                <section
                                  className={
                                    "d-flex align-items-end justify-content-between shadow-sm match-rounded " +
                                    (matchTeamIndex === 0
                                      ? "flex-row ps-1 ps-md-2 pe-0"
                                      : "flex-row-reverse pe-1 pe-md-2 ps-0")
                                  }
                                >
                                  <article
                                    className={
                                      "d-flex align-items-center py-1 py-md-2 " +
                                      (matchTeamIndex === 0
                                        ? "flex-row"
                                        : "flex-row-reverse")
                                    }
                                  >
                                    <img
                                      src={getFlagUrl(matchTeam.nation)}
                                      alt={matchTeam.nation}
                                    />
                                    <span
                                      className={
                                        "text-unselected groupstage-team-name " +
                                        (matchTeamIndex === 0 ? "ms-1" : "me-1")
                                      }
                                    >
                                      {matchTeam.nation}
                                    </span>
                                  </article>
                                  <article className="d-flex">
                                    <input
                                      className="form-control text-center input-score"
                                      type="number"
                                      value={matchTeam.goals}
                                      onChange={(event) =>
                                        changeTeamGoals(
                                          event,
                                          index,
                                          idx,
                                          matchTeamIndex
                                        )
                                      }
                                    />
                                  </article>
                                </section>
                                <article className="d-flex my-1">
                                  <span className="match-data text-danger">
                                    {!groupItem.isCalcBtnClicked ||
                                    groupItem.isAllFilled ||
                                    matchTeam.goals !== ""
                                      ? ""
                                      : "Debes ingresar los goles de este equipo"}
                                  </span>
                                </article>
                              </section>
                            );
                          })}
                          <article className="col-12 d-flex align-items-center justify-content-center mb-2 text-center">
                            <span className="match-data">
                              {match.matchDetail}
                            </span>
                          </article>
                        </div>
                      );
                    })}
                    <section className="col-12 d-flex justify-content-center my-3">
                      <button
                        className="btn btn-next text-white"
                        onClick={() => calcRanking(index)}
                      >
                        Calcular
                      </button>
                    </section>
                  </section>
                </div>
              </section>
              <section className="mt-2 mb-4 mb-md-5 px-1">
                <table className="w-100 table text-center">
                  <thead className="standing-head">
                    <tr>
                      <th>
                        <span className="mx-5"></span>
                      </th>
                      <th scope="col">
                        <span className="mx-1">PJ</span>
                      </th>
                      <th scope="col">
                        <span className="mx-1">PG</span>
                      </th>
                      <th scope="col">
                        <span className="mx-1">PE</span>
                      </th>
                      <th scope="col">
                        <span className="mx-1">PP</span>
                      </th>
                      <th scope="col">
                        <span className="mx-1">GF</span>
                      </th>
                      <th scope="col">
                        <span className="mx-1">GC</span>
                      </th>
                      <th scope="col">
                        <span className="mx-1">Dif.</span>
                      </th>
                      <th scope="col">
                        <span className="mx-1">Pts.</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupItem.teams.map((team, teamIndex) => {
                      return (
                        <tr
                          className={
                            "mb-1 standing-data " +
                            (teamIndex === 0 || teamIndex === 1
                              ? "text-selected to-knockout-stage-team"
                              : "text-unselected eliminated-team")
                          }
                          key={`groupTeams` + index + teamIndex}
                        >
                          <td>
                            <article className="d-flex align-items-center justify-content-start my-1 ms-1">
                              <img
                                className="px-1"
                                src={getFlagUrl(team.nation)}
                                alt={team.nation}
                              />
                              <span className="ms-1">{team.nation}</span>
                            </article>
                          </td>
                          <td>
                            <span>{team.pj}</span>
                          </td>
                          <td>
                            <span>{team.pg}</span>
                          </td>
                          <td>
                            <span>{team.pe}</span>
                          </td>
                          <td>
                            <span>{team.pp}</span>
                          </td>
                          <td>
                            <span>{team.gf}</span>
                          </td>
                          <td>
                            <span>{team.gc}</span>
                          </td>
                          <td>
                            <span>{team.dif}</span>
                          </td>
                          <td>
                            <span>{team.pts}</span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </section>
            </section>
          );
        })}
        {nextAvailable() ? (
          <section className="col-12 d-flex justify-content-center">
            <button
              className="btn btn-next text-white"
              type="button"
              onClick={() => dispatch(goTo16())}
            >
              SIGUIENTE
            </button>
          </section>
        ) : (
          <></>
        )}
      </section>
    </section>
  );
}

export default GroupStage;
